<template>
    <div class="passport">
        <ul>
            <li class="identity" v-for="(identity,index) of identities" :key="index">
                <div class="name">{{ identity.name.trim() }}</div>
                <div class="values">
                    <span class="value">{{ identity.value }}</span>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
import _ from 'lodash'

export default {
    name: 'Passport',
    props: ['passport'],
    computed: {
        identities() {
            return _.uniqBy(this.passport.identities.filter(identity => ['fingerprint'].indexOf(identity.id) == -1), 'value')
        }
    }
}
</script>
<style lang="less" scoped>
@import url('../assets/variables.less');

.passport {
    display: flex;
    margin-top: @gap;
    flex-wrap: wrap;
    flex-grow: 1;
    .identity {
        list-style-type: none;
        margin-right: @gap*2;
        order: 10;
        display: inline-block;
        .name {
            font-size: @font-size-s;
            color: @gray-50;
            margin-top: 0;
            font-weight: @normal;
        }
        .value {
            font-size: @font-size;
            color: @black;
        }
    }
    .identity.name {
        order: 0;
    }
    .identity.phone {
        order: 1;
    }
    .identity.email {
        order: 2;
    }
    .values {
        display: inline-flex;
    }
}
</style>